module.exports = __webpack_public_path__ + "static/media/arrow-left~GGCtlVZu.bf4b7868.svg";